'use client';

import { NotFoundPage } from '@/views/shared';

export default function NotFound() {
  return <NotFoundPage />;
}
